import React, { useEffect, useState } from "react";

const Loader = ({ active }) => {
  const [visible, setVisible] = useState(active);

  useEffect(() => {
    if (active) {
      setVisible(true);
    } else {
      const timer = setTimeout(() => setVisible(false), 300); // match transition duration
      return () => clearTimeout(timer);
    }
  }, [active]);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-bgMain/95 backdrop-blur-md transition-opacity duration-300 ${
        active ? "opacity-100" : "opacity-0"
      }`}
    >
      <div className="relative flex flex-col items-center">
        {/* Glowing casino wheel spinner */}
        <div className="relative w-24 h-24 flex items-center justify-center">
          <div className="absolute inset-0 border-4 border-dashed border-primaryColor/30 rounded-full animate-[spin_10s_linear_infinite]"></div>
          <div className="absolute inset-2 border-4 border-primaryColor border-t-transparent rounded-full animate-[spin_1.5s_cubic-bezier(0.4,0,0.2,1)_infinite] shadow-[0_0_25px_rgba(99,102,241,0.35)]"></div>
        </div>

        {/* Pulsing Spade/Chip Icon in Center */}
        <div className="absolute top-8 flex items-center justify-center animate-[pulse_2s_ease-in-out_infinite]">
          <svg
            className="w-8 h-8 text-accentColor drop-shadow-[0_0_8px_rgba(16,185,129,0.5)]"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            {/* Spade shape */}
            <path d="M12 2C9 7 3 9 3 13.5C3 17 6 19.5 9.5 19.5C11 19.5 11.5 19 12 18.5C12.5 19 13.5 19.5 14.5 19.5C18 19.5 21 17 21 13.5C21 9 15 7 12 2Z" />
            <path d="M12 17V22H10.5C10.5 22 12 20.5 12 17Z" />
          </svg>
        </div>

        {/* Typography */}
        <div className="mt-8 text-center">
          <h2 className="text-3xl font-black tracking-[0.2em] text-white">
            TRUSTED<span className="text-primaryColor">CASINOBRANDS</span>
          </h2>
          <p className="text-[10px] uppercase tracking-[0.4em] text-textMuted mt-2 animate-pulse">
            Loading Premium Reviews
          </p>
        </div>
      </div>
    </div>
  );
};

export default Loader;
